import * as React from "react";
const SvgGisMappingIconConv = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.27 14.952 1.593-5.09 5.089-1.592-1.593 5.089z"
      clipRule="evenodd"
    />
    <circle
      cx={11.611}
      cy={11.611}
      r={9.611}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgGisMappingIconConv;
